import React from 'react';

const Policy = () => (
  <div className="modal-content p-3">
    <div className="modal-header">
      <h2 className="h4 font-weight-bold my-0"><i className="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i> Travel &amp; Travel Pty Ltd 利用規約</h2>
    </div>
    <div className="modal-body">
    <div className="border p-2 my-3 bg-light rounded">
      <h2 className="h5 font-weight-bold mt-0 mb-1"><span className="text-danger">*</span> カード認証について</h2>
      <img className="img-rounded img-thumbnail mb-2" alt="" src="/themes/travel/dev/images/pending.jpg" />
      <p className="font-size-sm mb-0">お申し込み時に、クレジットカードが有効であることと、本人確認のために$0または、$1 がホールドされますが、実際に請求されることはありません（Pending状態）。<br />1日ー7日以内に認証用の$0または、$1はクレジットカード履歴から表示がなくなります。</p>
    </div>
      <p className="font-size-sm">当社はオーストラリア/ニュージーランドにおけるオプショナルツアー提供に関して代理媒介するもので、当社自身はオプショナルツアー主催責任者ではございません。オンライン申込みを頂いた時点でTravel &amp; Travel（以下当社）規約内容に承諾を頂いたものと致します。必ず最後までご確認ください。</p>

      <h2 className="h5 font-weight-bold mt-0 mb-1">円相場について</h2>

      <p className="font-size-sm">お支払いは表示されているオーストラリアドルの金額です。円で表示されている金額は一般的な為替相場での金額です。<br />
        <span>日本のクレジットカードでお支払い頂いた場合、お客様の銀行為替レートで円に換算されます。その際表示されている円の金額と異なることがございますので予めご了承ください。</span></p>

      <h2 className="h5 font-weight-bold mt-0 mb-1">旅行保険加入のお願い</h2>

      <p className="font-size-sm"><span><strong>ツアー代金に旅行損害保険料金は含まれておりません。</strong></span>旅行中の怪我、盗難、事故などツアー催行会社の責任に帰するべき事由により起因する全ての損害に関して当社は一切責任を負いません。お客様のパスポート期限切れやビザ状態、飛行機の遅延、旅行中の不測の事故や病気に対する備えとしてお客様ご自身で<strong>旅行損害保険</strong>に加入いただくことを強くお勧めいたします。</p>

      <h2 className="h5 font-weight-bold mt-0 mb-1">お申込み・お支払いに関して</h2>

      <p className="font-size-sm">お支払いの確認ができた時点でご予約へ移ります。カードでのお支払が確認できない場合、ご予約を完了することができませんのでご注意ください。お支払いが完了できない場合は、お電話にてお支払いも可能です。</p>

      <h3>カード手数料について</h3>

      <p className="font-size-sm">当社ではカード手数料を頂いておりません。オンラインで表示されているツアー代金（豪ドル）のみをお支払いください。</p>

      <h3>表示されている金額・お見積り金額について</h3>

      <p className="font-size-sm">各ツアー会社より、予告なく料金が変更されることがあります。弊社のウェブサイト価格が割引となっていても、すでにその価格での販売が終了していることもございます。万が一弊社のウェブサイト価格と実際の価格が異なっていた場合は、お引き落とし前にご連絡させて頂きます。<br />
        また、お見積り段階でご案内させて頂いた料金が変更した場合も、担当スタッフから新しいお見積料金を連絡させて頂きます。<br />
        料金を改めてご確認いただき、お支払い&rarr;ご予約となります。それまでは引き落としは発生いたしません。</p>

      <h2 className="h5 font-weight-bold mt-0 mb-1">ツアー内容・スケジュールについて</h2>

      <p className="font-size-sm">ホームページにて記載されておりますツアースケジュールは、あくまでもサンプル日程でございます。当日のガイドにより、記載内容のスケジュールと異なる場合がございます。<br />
        また、予告なくスケジュールが変更される場合もございます。その場合でも返金は致しかねます。その点をご理解いただいた上で、お申込みをお願い致します。</p>

      <h3>満席の場合</h3>

      <p className="font-size-sm">オンラインでツアー予約をお申込み頂いた場合でも満席などが理由でツアー予約を完了できない場合がございます。その場合、ツアー料金のお支払いは発生しません。</p>

      <h2 className="h5 font-weight-bold mt-0 mb-1">キャンセル・変更に関して</h2>

      <h3>キャンセル・日付変更</h3>

      <p className="font-size-sm">全てのツアー・チケットお申込みを頂いた時点でキャンセル料金が代金の100％発生します。ツアーの日程変更は空席があれば３営業日前まで承ります。<br />
        チケットにつきましては、日付変更はできません。また、一旦予約が完了すると日程変更も不可能なツアーもございます。各ツアー紹介ページの注意事項をよくご確認の上、お申込みをお願いいたします。</p>

      <h3>ツアー内容の変更</h3>

      <p className="font-size-sm">山火事や、大雨などの天候や、ツアー催行会社の拠無い事情により、ツアー内容やスケジュールが当日変更されることもございます。お客様の安全や利便性を第一に考えた上での変更になります。ツアー内容が変更した場合でも弊社からの返金は一切ございません。予めご了承ください。</p>

      <p className="font-size-sm">&nbsp;</p>

      <h3>ツアー料金の返金について</h3>

      <p className="font-size-sm">ツアー催行会社の都合でツアーがキャンセルとなった場合を除き、弊社からの返金は一切ございません。</p>

      <div>ツアー不催行の場合天候や事故が原因でツアー催行会社の決定によりツアーが不催行になった場合、当社でお申し込みいただいたツアー料金を返金させて頂きます。ツアー料金のご返金はオーストラリアの銀行口座へのお振込となります。オーストラリアの銀行口座をお持ちでない方は、お支払い頂いたクレジットカードへご返金させて頂きます。お現金でのご返金はいたしかねます。</div>

      <h3>為替の変動について</h3>

      <p className="font-size-sm">ツアー料金返金額はお支払いいだただいたツアー代金（豪ドル）のみとなります。為替などの変動に合わせた返金額の上乗せはいたしかねます。予めご了承を頂いた上でツアーにお申込みください。</p>

      <h2 className="h5 font-weight-bold mt-0 mb-1">各種お申込みについて</h2>

      <h3>航空券・ホテルのご予約について</h3>

      <p className="font-size-sm">航空券・ホテルのご予約につきましては、弊社と取引のあるチケット発券会社の規定に従い、弊社で設定したキャンセル料金・日程変更手数料が発生します。この規約は航空会社やホテルのキャンセル規定ではございませんので予めご了承ください。</p>

      <h3>バス・電車のご予約について</h3>

      <p className="font-size-sm">バス・電車につきましては、予約完了後はキャンセル・日程変更共に不可となります。</p>

      <h3>パスポート・ビザ（査証）</h3>

      <p className="font-size-sm">パスポートの有効期限が、帰国日より6ヶ月未満の場合、渡航国によっては入国できない場合がございます。またビザ（入国許可書）につきましては、必ずご自身にて、各国大使館などにご確認お願い致します。</p>

      <h2 className="h5 font-weight-bold mt-0 mb-1">飛行機についての注意</h2>

      <h3>機内持ち込み荷物について</h3>

      <p className="font-size-sm">航空会社により、機内持ち込み荷物の重さ・大きさの規定が異なります。ご出発時に規定が変更になることもございますので、詳細はお客様自身でもご利用の航空会社へお問い合わせください。</p>

      <h3>受託手荷物について</h3>

      <p className="font-size-sm">国際線につきましては、液体物やクリーム状の持ち込み制限がございます。詳しくは各航空会社へお問い合わせ下さい。</p>

      <h3>飛行機出発時間変更について</h3>

      <p className="font-size-sm">予約時の出発時間と、当日の出発時間は変更されることがあります。ご出発日までに、ご利用の航空会社に再度出発時間の確認をお願い致します。</p>

      <h3>集合時間に間に合わなかった場合</h3>
      <p className="font-size-sm">ツアー当日に電車、バス、飛行機の遅延などによってツアー集合時間に間に合わなかった場合、自動的に当日のキャンセルとなり、返金は一切致しかねますのでご注意ください。旅行損害保険加入をお勧め致します。</p>

    </div>
  </div>
);

export default Policy;



// WEBPACK FOOTER //
// ./src/pages/purchase/components/Policy.js